<div class="cluster-map-marker-wrapper">
    <div class='price-cluster-wrapper'>
        <div class='price-cluster-counter'>{{summary().nrItems || 0 }}</div>
        <div class='price-cluster-price-range'>
            <div class="value">{{summary().minValue | number : "1.0-1" | dash}}</div>
            <div class="nav-push-right"></div>
            <div class="value">{{summary().maxValue | number : "1.0-1" | dash}} </div>
            <div class="unit">mill</div>
        </div>
    </div>
</div>